import styled, { css } from 'styled-components';
import { getBrandColorUsingCssFilterOnImg } from '@/utils/cssColorFilters.ts';
import type { Localization } from '../../../../../common/Localization';
import { checkboxHoverColor } from '../../../../../styles/colors';

export const ListViewSortContainer = styled.div`
  display: none;
  width: 100%;
  align-items: center;
  height: 56px;
  border-radius: 8px;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.kallisto.color.common.white[1000]};
  position: relative;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row;
  }
`;

export const Expand = styled.button<{ isSelected: boolean; localization: Localization; isLoading: boolean }>`
  height: 56px;
  width: 52px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  cursor: pointer;
  background: transparent;
  border-radius: 0 8px 8px 0;

  ${({ localization, isLoading }) =>
    localization &&
    !isLoading &&
    css`
    &:hover {
    ${getBrandColorUsingCssFilterOnImg(localization.brand)}
    `}

  ${({ localization, isSelected }) =>
    localization && isSelected && getBrandColorUsingCssFilterOnImg(localization.brand)}
`;

export const Overlay = styled.div`
  width: 260px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 0;
  top: 56px;
  background-color: #fff;
  z-index: 4;
  border-radius: 8px;
  box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
`;

export const OverlayItem = styled.div<{ isSelected?: boolean; localization: Localization }>`
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  height: 56px;
  width: 100%;
  padding: 0 12px;
  cursor: pointer;
  border-radius: 8px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  ${({ theme }) => theme.kallisto.mixins.font('Body')};

  &:hover {
    background-color: ${checkboxHoverColor};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${checkboxHoverColor};
    `}
  img {
    margin-left: auto;
  }
`;

export const RankingLabel = styled.div`
  line-height: 24px;
`;

export const RankingContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: initial;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};

  a {
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    text-decoration: underline;
  }
`;

export const TooltipContainer = styled.div`
  a {
    text-decoration: underline;
  }
`;
